<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  [ngStyle]="overrideStyle"
>
  <path
    d="M6.0188 12.5817C6.0188 13.001 6.50376 13.234 6.83115 12.9721L12.2808 8.61245C12.531 8.41229 12.531 8.03175 12.2808 7.83159L6.83115 3.4719C6.50376 3.20999 6.0188 3.44308 6.0188 3.86233V12.5817Z"
    fill="white"
  />
  <path
    d="M4.35127 3.22827C4.84664 3.22827 5.26837 3.50679 5.26837 3.85605V12.5079C5.30184 13.3434 3.36053 13.3434 3.394 12.5079V3.85605C3.36053 3.50679 3.82243 3.22827 4.35127 3.22827Z"
    fill="white"
  />
</svg>
